import Login from "../pos-LoginScreen/Injaz-LoginScreen";
// import { connect } from 'react-redux';

// import { loginThunka } from '../../redux/actions/posloginAction.js'

// const mapStateToProps = ({user}) => ({
// 	user
// });
// const mapStateToProps = state => {
// 	// return {
// 	//   objects: state.objectIds.map(id => state.objects[id])
// 	// }
// 	return state;
//   }

// const mapDispatchToProps = dispatch => ({
//     loginThunka: (usernameOrEmail, password) => dispatch(loginThunka(usernameOrEmail, password))
//     // ,
// 	// tokenAuthThunk: () => dispatch(tokenAuthThunk()),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Login);
export default Login;
